import {
  SCORE_CARD_CALCULATE,
  SCORE_CARD_CALCULATE_CLEAR,
} from "../types/scoreCardCalculate";
import createAsyncActions from "../../../utilities/createAsyncActions";
import { createAction } from "redux-actions";

export const {
  scoreCardCalculate,
  scoreCardCalculatePending,
  scoreCardCalculateFulfilled,
  scoreCardCalculateRejected,
} = createAsyncActions(SCORE_CARD_CALCULATE, "scoreCardCalculate");

export const clearScoreCardCalculateActionsSubmittedState = createAction(
  SCORE_CARD_CALCULATE_CLEAR
);



// WEBPACK FOOTER //
// ./src/features/score-card/actions/scoreCardCalculateActions.js